import { Application } from '@hotwired/stimulus'
import CheckboxSelectAll from 'stimulus-checkbox-select-all'
import Popup from './front_stage/popup_controller'

const application = Application.start()
application.register('checkbox-select-all', CheckboxSelectAll)
application.register('popup', Popup)

// Configure Stimulus development experience
application.warnings = true
application.debug = false
window.Stimulus = application

export { application }
export default application
